module.exports = __webpack_public_path__ + "img/gb.851b1f05.svg";